var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('headerVue'),_c('div',{staticClass:"main-content",class:{ 'full-width': _vm.isFullWidth }},[_c('router-view')],1),_c('footerVue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }